import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBrand, useBrandLoading } from 'scripts/brand/BrandContext'
import { toSafeExternalUrl } from 'scripts/safeExternalUrl'

// OEM / ホワイトラベル対応: partner_brand_settings.zendesk_form_url が設定されていれば
// サポート窓口リンクを出す。未設定なら何も表示しない（LOCKED デフォルトでも）。
const SupportLink: React.FC = () => {
  const { t } = useTranslation()
  const brand = useBrand()
  const brandLoading = useBrandLoading()
  // brand 解決前は出さない（DEFAULT の support URL を一瞬出さない）。
  if (brandLoading) return null

  const supportUrl =
    toSafeExternalUrl(brand?.zendeskFormUrl) ||
    toSafeExternalUrl(brand?.supportUrl)
  if (!supportUrl) return null

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        background: '#fff',
        padding: '8px 14px',
        borderRadius: 6,
        boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
        zIndex: 999,
      }}
    >
      <a
        href={supportUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ fontSize: 13, textDecoration: 'none' }}
      >
        {t('サポートに問い合わせ')}
      </a>
    </div>
  )
}

export default SupportLink
